import { render, staticRenderFns } from "./Combobox.vue?vue&type=template&id=4982dce0"
import script from "./Combobox.vue?vue&type=script&setup=true&lang=ts"
export * from "./Combobox.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports